if (!customElements.get('image-accordion')) {
  customElements.define(
    'image-accordion',
    class ImageAccordion extends HTMLElement {
      constructor() {
        super()
  
        this.setNodeSelectors()
        this.setEventListeners()
        this.setImageContainerHeight()
      }

      /**
       * Sets the node selectors.
       */
      setNodeSelectors() {
        this.nodeSelectors = {
          toggles: this.querySelectorAll('[js-image-accordion="toggle"]'),
          items: this.querySelectorAll('[js-image-accordion="item"]'),
          images: this.querySelectorAll('[js-image-accordion="image"]'),
          imagesContainer: this.querySelector('[js-image-accordion="images"]')
        }
      }

      /**
       * Sets event listeners on elements.
       */
      setEventListeners() {
        window.addEventListener('resize', throttle(this.setImageContainerHeight.bind(this)))

        this.nodeSelectors.toggles.forEach((element) => {
          element.addEventListener('click', this.handleToggleMouseenter.bind(this))
        })
      }

      /**
       * Handles an item's toggle `mouseenter` event.
       * @param {Object} event - The event payload.
       */
      handleToggleMouseenter(event) {
        const item = event.target.closest('[js-image-accordion="item"]')
  
        if (item.classList.contains('is-active')) {
          /**
           * Close the current item, but keep the image active (2nd argument).
           */
          this.closeItem(item, true)
          return
        }

        this.closeOtherItems(item)
        this.openItem(item)
      }

      /**
       * Opens an accordion element.
       * @param {HTMLElement} element - The element to open.
       */
      openItem(element) {
        const content = element.querySelector('[js-image-accordion="content"]')
        const image = this.getItemImage(element)

        element.classList.add('is-active')

        if (content) {
          /**
           * @todo replace with vanilla JavaScript
           */
          $(content).slideDown(300)
        }

        if (image) {
          /**
           * @todo replace with vanilla JavaScript
           */
          image.classList.add('is-active')

          this.setImageContainerHeight()
        }
      }

      /**
       * Closes an accordion element.
       * @param {HTMLElement} element - The element to close.
       * @param {Boolean} keepImage - Stops the image from being hidden.
       */
      closeItem(element, keepImage) {
        const content = element.querySelector('[js-image-accordion="content"]')
        const image = this.getItemImage(element)

        element.classList.remove('is-active')

        if (content) {
          /**
           * @todo replace with vanilla JavaScript
           */
          $(content).slideUp(300)
        }

        if (image && !keepImage) {
          /**
           * @todo replace with vanilla JavaScript
           */
          image.classList.remove('is-active')
        }
      }

      /**
       * Closes all items except the given element.
       * @param {HTMLElement} itemToIgnore - The element to keep open.
       */
      closeOtherItems(itemToIgnore) {
        this.nodeSelectors.items.forEach((element) => {
          if (element === itemToIgnore) {
            return
          }

          this.closeItem(element)
        })
      }

      /**
       * Returns the image element for the item, if it exists.
       * @param {HTMLElement} element - The parent item.
       */
      getItemImage(element) {
        if (!element.id) {
          return null
        }

        return this.querySelector(`[js-image-accordion="image"][data-item="${element.id}"]`)
      }

      /**
       * Sets the height of the image container based on the active image.
       */
      setImageContainerHeight() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.nodeSelectors.imagesContainer.style.height = '100%'
          return
        }

        this.nodeSelectors.images.forEach((image) => {
          if (image.classList.contains('is-active')) {
            setTimeout(() => {
              this.nodeSelectors.imagesContainer.style.height = `${image.scrollHeight}px`
            }, 0)
          }
        })
      }
    }
  )
}
